import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'
import Storage from '../services/Storage'

let intervalRef;
function* login(action) {
  try {
    const user = yield call(function () {
      const {token} = action.payload;
      return Api.post(`/ddp/auth?token=${token}`);
    });
    yield put({type: 'LOGIN.SUCCESS', user})
  } catch (error) {
    yield put({type: 'LOGIN.FAILURE', error})
    yield put({type: 'LOGOUT.REQUEST', error})
  }

}

function* customerLogin(action) {
  try {
    const response = yield call(function () {
      const {username, password} = action.payload;
      const form = new FormData();
      form.append('username', username);
      form.append('password', password);
      return Api.post(`/public/connected/token`, form);
    });
    yield put({type: 'FETCH.CUSTOMER_LOGIN.SUCCESS', response})
  } catch (error) {
    yield put({type: 'FETCH.CUSTOMER_LOGIN.FAILURE', error})
    yield put({type: 'CUSTOMER_LOGOUT.REQUEST', error})
  }

}


function* customerRefreshToken() {
  try {
    const response = yield call(function () {
      return Api.post(`/connected/token/refresh`, {refreshToken:Storage.getSessionItem("connected-refresh-token")});
    });
    yield put({type: 'FETCH.CUSTOMER_REFRESH_TOKEN.SUCCESS', response})

  } catch (error) {
    yield put({type: 'FETCH.CUSTOMER_REFRESH_TOKEN.FAILURE', error})
    yield put({type: 'CUSTOMER_LOGOUT.REQUEST', error})
  }

}

function* customerExchangeToken(action) {
  try {
    const form = new FormData();
    form.append('token', action.params.token);
    const response = yield call(function () {
      return Api.post(`/public/connected/token`, form);
    });
    yield put({type: 'FETCH.CUSTOMER_EXCHANGE_TOKEN.SUCCESS', response})

  } catch (error) {
    yield put({type: 'FETCH.CUSTOMER_EXCHANGE_TOKEN.FAILURE', error})
    yield put({type: 'CUSTOMER_LOGOUT.REQUEST', error})
  }

}

function* logout(action) {
    yield put({type: 'LOGOUT.SUCCESS'})

}

function* customerLogout(action) {
  yield put({type: 'CUSTOMER_LOGOUT.SUCCESS'})

}

export function* watchLogin() {
  yield takeEvery('LOGIN.REQUEST', login);
  yield takeEvery('LOGOUT.REQUEST', logout);
  yield takeEvery('FETCH.CUSTOMER_LOGIN.REQUEST', customerLogin);
  yield takeEvery('FETCH.CUSTOMER_REFRESH_TOKEN.REQUEST', customerRefreshToken);
  yield takeEvery('FETCH.CUSTOMER_EXCHANGE_TOKEN.REQUEST', customerExchangeToken);
  yield takeEvery('CUSTOMER_LOGOUT.REQUEST', customerLogout);
}



// WEBPACK FOOTER //
// ./src/sagas/authentication.js